import { render, staticRenderFns } from "./ProfileDeleteAccount.vue?vue&type=template&id=39869471&scoped=true"
import script from "./ProfileDeleteAccount.vue?vue&type=script&lang=js"
export * from "./ProfileDeleteAccount.vue?vue&type=script&lang=js"
import style0 from "./ProfileDeleteAccount.vue?vue&type=style&index=0&id=39869471&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39869471",
  null
  
)

export default component.exports